import {
	Component,
	EventEmitter,
	Input,
	Output,
	ViewChild,
	ChangeDetectionStrategy,
} from "@angular/core"
import { ActivatedRoute, Router } from "@angular/router"
import { COMMON_IMPORTS } from "../common-imports"
import { flipYesNo } from "@app/helpers"
import { ApiService } from "@app/services/api.service"
import { EventsService } from "@app/services/events.service"
import { LangService } from "@app/services/lang.service"
import { ModalService } from "@app/services/modal.service"
import { OverlapService } from "@app/services/overlap.service"
import { PermsService } from "@app/services/perms.service"
import { SearchSortService } from "@app/services/search-sort.service"
import { StoreService } from "@app/services/store.service"
import { ValidatorService } from "@app/services/validator.service"
import { WysiwygComponent } from "@app/utils/wysiwyg/wysiwyg.component"
import { PatientModalComponent, YesNo } from "@app/utils/utils.component"
import { GenAutocompleteComponent } from "@app/gen-inputs/gen-autocomplete/gen-autocomplete.component"
import { GenInputComponent } from "@app/gen-inputs/gen-input/gen-input.component"
import { GenButtonGroupComponent } from "@app/gen-inputs/gen-button-group/gen-button-group.component"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { AutotextMenuComponent } from "@app/autotext-menu/autotext-menu.component"
import { TestsMenuComponent } from "@app/tests-menu/tests-menu.component"
import { LangValPipe } from "@app/utils/lang-val.pipe"

@Component({
	selector: "[app-group-attends-row]",
	imports: [
		COMMON_IMPORTS,
		YesNo,
		WysiwygComponent,
		PatientModalComponent,
		GenAutocompleteComponent,
		GenInputComponent,
		GenButtonGroupComponent,
		ModalWrapComponent,
		AutotextMenuComponent,
		TestsMenuComponent,
		LangValPipe,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./group-attends-row.component.html",
})
export class GroupAttendsRowComponent {
	modalProps: any = null
	@Input() row: any
	@Input() isManualChargeShown: string
	@Output() updated = new EventEmitter()
	@ViewChild("descriptionWysiwyg") descriptionWysiwyg: WysiwygComponent
	hasPayors: boolean = false

	constructor(
		public lang: LangService,
		public apiService: ApiService,
		public modalService: ModalService,
		public eventsService: EventsService,
		public store: StoreService
	) {
		this.hasPayors = !!this.store.getSiteDataTable("payors").length
	}

	async updField(fieldName: string) {
		//update attends row
		//let newVal = (fieldName == "arrived" ? (row.arrived == "yes" ? "no" : "yes") : row.remarks);	//val is either arrived (flip "yes"/"no") or remarks
		const newVal =
			fieldName == "arrived" ? flipYesNo(this.row.arrived) : this.row[fieldName]
		this.row[fieldName] = newVal //update the field
		const res: any = await this.apiService.save_gen_field(
			"groupattends",
			this.row.id,
			fieldName,
			newVal
		)
		if (!res.success) {
			return
		}
		this.modalService.openToast("update_successfuly")
		this.updated?.emit()
	}
	injectDescription(text: string = "") {
		if (text) {
			this.descriptionWysiwyg.injectText(text)
		}
	}
}
